import { render, staticRenderFns } from "./LoginToShowKeyfiguresDialog.vue?vue&type=template&id=4fc6ff34"
import script from "./LoginToShowKeyfiguresDialog.vue?vue&type=script&lang=ts"
export * from "./LoginToShowKeyfiguresDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports